import React, { useState, useEffect } from "react";
import "../styles/Formularios.css";
import { useGlobal } from "../context/ContenedorGlobal";
import InputSelectIp from "./InputSelectIp";
import InputInventario from "./InputInventario";
import InputSelectEstados from "./InputSelectEstados";
import InputGenerico from "./InputGenerico";
import InputSelectGenerico from "./InputSelectGenerico";
import { useApiFetch } from "../utils/apiFetch";
import InputUsuarioAutocomplete from "./InputUsuarioAutocomplete";

function ModificarBienes() {
    const { permisos, setModuloActual, setSubModuloActual, bienSeleccionado, setBienSeleccionado, logout } = useGlobal();
    const apiFetch = useApiFetch();
    const [serieBien, setSerieBien] = useState("");
    const [datosBien, setDatosBien] = useState(null);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [loading, setLoading] = useState(false);
    const [inventarioNuevo, setInventarioNuevo] = useState("");
    const [idIp, setIdIp] = useState(null);
    const [serieOriginal, setSerieOriginal] = useState("");
    const [serieNueva, setSerieNueva] = useState("");
    const tienePermisoModificar = permisos.includes(19); // id_permiso=19 "Modificar Bienes"

    useEffect(() => {
        if (datosBien) {
            setInventarioNuevo(datosBien.inventario || "");
            setIdIp(datosBien.id_ip ? Number(datosBien.id_ip) : null);
            setSerieOriginal(datosBien.serie_bien || "");
            setSerieNueva(datosBien.serie_bien || "");
        }
    }, [datosBien]);

    /* Buscar bien manualmente
    const handleBuscar = async (e) => {
        e.preventDefault();
        setError("");
        setSuccess("");

        // Validar que exista dato y tenga formato correcto
        const serieTrim = (serieBien || "").trim().toUpperCase();
        if (!serieTrim) {
            setError("Debe ingresar la serie del bien.");
            return;
        }
        if (serieTrim.length < 2) {
            setError("La serie debe tener al menos 2 caracteres.");
            return;
        }

        setLoading(true);

        try {

            const data = await apiFetch("consultar_bien_especifico.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ serie_bien: serieBien })
            }, logout);

            if (data.status === "ok" && data.bien) {
                setDatosBien(data.bien);
            } else {
                setError(data.message || "Bien no encontrado.");
                setTimeout(() => {
                    setModuloActual("Hardware");
                    setSubModuloActual(null);
                }, 3000);
            }
        } catch {
            setError("Error de conexión con el servidor.");
        } finally {
            setLoading(false);
        }
    };
    */

    // Cargar bien automáticamente si viene desde ConsultarBienes.jsx
    useEffect(() => {
        if (bienSeleccionado) {
            const cargarBien = async () => {
                try {
                    const data = await apiFetch("consultar_bien_especifico.php", {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({ serie_bien: bienSeleccionado })
                    }, logout);

                    if (data.status === "ok" && data.bien) {
                        setDatosBien(data.bien);
                    } else {
                        setError(data.message || "Bien no encontrado.");
                    }
                } catch {
                    setError("Error al cargar bien.");
                }
            };

            cargarBien();
        }
    }, [bienSeleccionado]);

    // Cada vez que cambia el propietario, se valida el inventario
    useEffect(() => {
        const inventarioTrim = (inventarioNuevo ?? "").trim();
        if (datosBien?.id_propietario === 1 && inventarioTrim.length === 0) {
            setError("El inventario es obligatorio para bienes SICT.");
        } else {
            setError("");
        }
    }, [datosBien?.id_propietario, inventarioNuevo]);

    // Modificar bien
    const handleModificar = async (e) => {
        e.preventDefault();
        setSuccess("");

        // Validaciones forzosas
        if (!serieOriginal) {
            setError("No se detectó la serie original. Vuelve a cargar el bien antes de modificar.");
            return;
        }

        const serieTrim = (serieNueva || "").trim().toUpperCase();
        if (!serieTrim) {
            setError("Debe ingresar la nueva serie del bien.");
            return;
        }

        const marcaTrim = (datosBien?.marca || "").trim();
        if (!marcaTrim) {
            setError("Debe ingresar la marca del bien.");
            return;
        }

        const modeloTrim = (datosBien?.modelo || "").trim();
        if (!modeloTrim) {
            setError("Debe ingresar el modelo del bien.");
            return;
        }

        const versionTrim = (datosBien?.version_soft || "").trim();
        if (!versionTrim) {
            setError("Debe ingresar la versión de software.");
            return;
        }

        if (!datosBien?.id_tipo) {
            setError("Debe seleccionar un tipo de bien.");
            return;
        }

        if (!datosBien?.id_estado) {
            setError("Debe seleccionar un estado del bien.");
            return;
        }

        if (!datosBien?.id_propietario) {
            setError("Debe seleccionar un propietario.");
            return;
        }

        if (!datosBien?.id_resg) {
            setError("Debe seleccionar un resguardante.");
            return;
        }

        if (!datosBien?.id_uso) {
            setError("Debe seleccionar un usuario operador.");
            return;
        }

        // Validación condicional de inventario
        const inventarioTrim = (inventarioNuevo ?? "").trim();
        if (datosBien?.id_propietario === 1 && inventarioTrim.length === 0) {
            setError("El inventario es obligatorio para bienes SICT.");
            return;
        }

        setLoading(true);

        try {
            const payload = {
                serie_original: serieOriginal,
                serie_nueva: serieTrim,
                inventario_actual: datosBien?.inventario || "",
                inventario_nuevo: inventarioTrim || "",
                id_ip: idIp || null,
                marca: marcaTrim,
                modelo: modeloTrim,
                version_soft: versionTrim,
                id_tipo: datosBien?.id_tipo || null,
                id_estado: datosBien?.id_estado || null,
                id_propietario: datosBien?.id_propietario || null,
                id_resg: datosBien?.id_resg || null,
                id_uso: datosBien?.id_uso || null,
                id_permiso: 19
            };

            const data = await apiFetch("modificar_bienes.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload)
            }, logout);

            if (data.status === "ok") {
                setSuccess("\u2705 Bien modificado correctamente.");
                setDatosBien(prev => ({
                    ...prev,
                    serie_bien: data.serie_bien ?? payload.serie_nueva,
                    inventario: data.inventario ?? payload.inventario_nuevo,
                    id_ip: payload.id_ip
                }));
                setTimeout(() => {
                    setModuloActual("Hardware");
                    setSubModuloActual(null);
                    setBienSeleccionado(null);
                    setLoading(false);
                }, 3000);
            } else {
                setError(data.message || "Error al modificar bien.");
                setLoading(false);
            }
        } catch {
            setError("Error de conexión con el servidor.");
            setLoading(false);
            setTimeout(() => {
                setModuloActual("Hardware");
                setSubModuloActual(null);
                setBienSeleccionado(null);
                setLoading(false);
            }, 3000);
        }
    };

    if (!tienePermisoModificar) {
        return <p>Acceso denegado. No tiene permiso para modificar bienes.</p>;
    }

    return (
        <div className="sesion-form">

            {error && <div className="error">{error}</div>}
            {success && <div className="success">{success}</div>}

            {/*
            {!datosBien && (
                <form onSubmit={handleBuscar}>
                    <InputGenerico
                        value={serieBien}
                        setValue={setSerieBien}
                        label="Serie del bien"
                        maxLength={50}
                        allowedChars="A-Z0-9/_\-"
                        transform="uppercase"
                        placeholder="MXL1234ABC"
                        title="Máximo 50 caracteres"
                    />

                    <div className="form-buttons">
                        <button type="submit" disabled={loading}>
                            {loading ? "Buscando..." : "Buscar"}
                        </button>
                    </div>
                </form>
            )}
*/}

            {datosBien && (
                <form onSubmit={handleModificar}>

                    <InputGenerico
                        value={serieNueva}
                        setValue={setSerieNueva}
                        label="Serie nueva"
                        maxLength={30}
                        allowedChars="A-Z0-9/_\-"
                        transform="uppercase"
                        placeholder="MXL1234ABC"
                        title="Máximo 30 caracteres"
                    />

                    <InputSelectGenerico
                        idSeleccionado={datosBien.id_tipo}
                        setIdSeleccionado={(value) => setDatosBien({ ...datosBien, id_tipo: value })}
                        label="Tipo de bien"
                        apiUrl={`consultar_tipo_bienes.php`}
                        valueField="id_tipo"
                        displayField="tipo_bien"
                        showDefaultOption={true}
                        defaultOptionText="Seleccione un tipo"
                    />

                    <InputGenerico
                        value={datosBien.marca}
                        setValue={(value) => setDatosBien({ ...datosBien, marca: value })}
                        label="Marca"
                        maxLength={50}
                        allowedChars="A-Z0-9/_\- "
                        transform="uppercase"
                        placeholder="HP"
                    />

                    <InputGenerico
                        value={datosBien.modelo}
                        setValue={(value) => setDatosBien({ ...datosBien, modelo: value })}
                        label="Modelo"
                        maxLength={50}
                        allowedChars="A-Z0-9/_\- "
                        transform="uppercase"
                        placeholder="PRODESK 700"
                    />

                    <InputGenerico
                        value={datosBien.version_soft}
                        setValue={(value) => setDatosBien({ ...datosBien, version_soft: value })}
                        label="Versión software"
                        maxLength={50}
                        allowedChars="A-Z0-9/_\- "
                        transform="uppercase"
                        placeholder="WINDOWS 11"
                    />

                    <InputUsuarioAutocomplete
                        idSeleccionado={datosBien?.id_resg}
                        setIdSeleccionado={(val) => setDatosBien({ ...datosBien, id_resg: val })}
                        label={
                            datosBien?.a_paterno
                                ? `Resguardante actual: ${datosBien.a_paterno} ${datosBien.a_materno} ${datosBien.usuario}`
                                : "Resguardante"
                        }
                        placeholder="Ingrese apellido paterno"
                        title="Seleccione al usuario resguardante"
                        readOnly={false}
                        maxLength={50}
                    />

                    <InputUsuarioAutocomplete
                        idSeleccionado={datosBien?.id_uso}
                        setIdSeleccionado={(val) => setDatosBien({ ...datosBien, id_uso: val })}
                        label={
                            datosBien?.a_paterno
                                ? `Operador actual: ${datosBien.a_paterno} ${datosBien.a_materno} ${datosBien.usuario}`
                                : "Operador"
                        }
                        placeholder="Ingrese apellido paterno"
                        title="Seleccione al usuario operador"
                        readOnly={false}
                        maxLength={50}
                    />

                    <InputSelectEstados
                        idEstado={datosBien.id_estado}
                        setIdEstado={(value) => setDatosBien({ ...datosBien, id_estado: value })}
                        estadoActualText={datosBien.estado_actual}
                        idEntidad={1}
                        label="Estado del bien"
                        apiUrl={`consultar_estados.php`}
                    />

                    {/* Condición para aprovechar recursos IP */}
                    {[1, 2, 4].includes(Number(datosBien.id_estado)) && (
                        <InputSelectIp
                            idIp={idIp}
                            setIdIp={setIdIp}
                            estadoFiltro="DISPONIBLE"
                            label={`Ip actual: ${datosBien.ip}`}
                        />
                    )}

                    <InputSelectGenerico
                        idSeleccionado={datosBien.id_propietario || ""}
                        setIdSeleccionado={(value) => setDatosBien({ ...datosBien, id_propietario: value })}
                        label="Propietario"
                        apiUrl={`consultar_propietarios.php`}
                        valueField="id_propietario"
                        displayField="propietario"
                        showDefaultOption={true}
                        defaultOptionText="Seleccione el propietario"
                    />

                    {/* Condición cuando el propietario es la misma organización */}
                    {Number(datosBien.id_propietario) === 1 && (
                        <InputInventario
                            inventario={inventarioNuevo}
                            setInventario={setInventarioNuevo}
                        />
                    )}

                    <div className="form-buttons">
                        <button
                            type="submit"
                            disabled={loading || (Number(datosBien?.id_propietario) === 1 && !inventarioNuevo.trim())}
                        >
                            {loading ? "Procesando..." : "Modificar"}
                        </button>
                    </div>
                </form>
            )}



        </div>
    );
}

export default ModificarBienes;